import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=547230ea&scoped=true&"
import script from "./Home.vue?vue&type=script&language=javascript&lang=js&"
export * from "./Home.vue?vue&type=script&language=javascript&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=547230ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547230ea",
  null
  
)

export default component.exports